import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IRegisterUser } from '@app/shared/interfaces/users.interface';
import { HttpService } from '@app/shared/services/http/http.service';
import { UrlService } from '@app/shared/services/url/url.service';
import { Observable, catchError, delay, of, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  constructor(private _httpService: HttpService, private _urlService: UrlService) {}

  getUsers(searchField: string, pages: { page: number; pageSize: number }): Observable<any> {
    const url = this._urlService.getUrl('COLLECT.getUsers', {});
    return this._httpService
      .post(url, { searchKeys: { search: searchField }, ...pages })
      .pipe(catchError((error: any) => throwError(error)));
  }

  createUser(data: IRegisterUser): Observable<any> {
    const url = this._urlService.getUrl('COLLECT.createUser', {});
    return this._httpService
      .post(url, data, {})
      .pipe(catchError((error: any) => throwError(error)));
  }

  resetUserPassword(data: { Id: string; newPassword: string }): Observable<any> {
    const url = this._urlService.getUrl('COLLECT.resetUserPassword', {});
    return this._httpService.put(url, data).pipe(catchError((error: any) => throwError(error)));
  }

  changeUserStatus(data: { userId: string; newStatus: boolean }): Observable<any> {
    const url = this._urlService.getUrl('COLLECT.changeUserStatus', {});
    return this._httpService.put(url, data).pipe(catchError((error: any) => throwError(error)));
  }

  confirmEmailToResetPassword(data: { email: string }): Observable<any> {
    const url = this._urlService.getUrl('COLLECT.confirmEmailResetPassword');
    return this._httpService.post(url, data).pipe(catchError((error: any) => throwError(error)));
  }

  updateUser(data: IRegisterUser): Observable<any> {
    const url = this._urlService.getUrl('COLLECT.updateUser');
    return this._httpService.post(url, data).pipe(catchError((error: any) => throwError(error)));
  }
}
